import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IYearlevel_map } from "../../../Pages/Yearlevel_map/IYearlevel_map";

export const ListRegistrationYeargroupSlice = createSlice({
    name: "ListRegistrationYeargroupSlice",
    initialState: {} as IReduxState<IYearlevel_map[]>,
    reducers: {
        listRegistrationYeargroup: (state) => {
            state.isLoading = true;
        },
        successlistRegistrationYeargroup: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failurelistRegistrationYeargroup: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
    },
});

export const {
    failurelistRegistrationYeargroup,
    listRegistrationYeargroup,
    successlistRegistrationYeargroup,
} = ListRegistrationYeargroupSlice.actions;

export default ListRegistrationYeargroupSlice.reducer;
